import { createFileRoute } from "@tanstack/react-router";
import { AccountSettings } from "./-account/AccountSettings";

export const Route = createFileRoute("/$workspace/account")({
  staticData: { title: "Your account" },
  component: AccountSettings,
});
